/* ==========================================================================
   Hard4Life — Wunschliste für Dawn
   Speichert die gemerkten Produkte im Browser des Kunden (localStorage).
   Keine App nötig, keine laufenden Kosten.
   ========================================================================== */
(function () {
  var SCHLUESSEL = 'h4l_wunschliste';

  function lesen() {
    try {
      var roh = window.localStorage.getItem(SCHLUESSEL);
      var liste = roh ? JSON.parse(roh) : [];
      return Array.isArray(liste) ? liste : [];
    } catch (e) {
      return [];
    }
  }

  function schreiben(liste) {
    try {
      window.localStorage.setItem(SCHLUESSEL, JSON.stringify(liste));
    } catch (e) {}
    zaehlerAktualisieren();
  }

  function enthalten(handle) {
    return lesen().indexOf(handle) !== -1;
  }

  function umschalten(handle) {
    var liste = lesen();
    var pos = liste.indexOf(handle);
    if (pos === -1) {
      liste.push(handle);
    } else {
      liste.splice(pos, 1);
    }
    schreiben(liste);
    return liste.indexOf(handle) !== -1;
  }

  function entfernen(handle) {
    var liste = lesen().filter(function (h) { return h !== handle; });
    schreiben(liste);
  }

  /* --- Sternchen auf Produktseiten und Karten ----------------------------- */
  function sterneVorbereiten() {
    document.querySelectorAll('[data-h4l-wish]').forEach(function (knopf) {
      if (knopf.dataset.bereit === 'true') return;
      knopf.dataset.bereit = 'true';
      var handle = knopf.getAttribute('data-handle');
      if (!handle) return;

      function malen() {
        var drin = enthalten(handle);
        knopf.classList.toggle('is-gemerkt', drin);
        knopf.setAttribute('aria-pressed', drin ? 'true' : 'false');
        knopf.setAttribute('aria-label', drin ? 'Von der Wunschliste entfernen' : 'Zur Wunschliste hinzufügen');
      }

      knopf.addEventListener('click', function (e) {
        e.preventDefault();
        umschalten(handle);
        malen();
      });

      malen();
    });
  }

  /* --- Zaehler im Header ------------------------------------------------- */
  function zaehlerAktualisieren() {
    var anzahl = lesen().length;
    document.querySelectorAll('[data-h4l-wish-count]').forEach(function (el) {
      el.textContent = anzahl;
      el.hidden = anzahl === 0;
    });
  }

  /* --- Symbol in Dawns Header einhängen ---------------------------------- */
  function headerSymbol() {
    var leiste = document.querySelector('.header__icons');
    if (!leiste || leiste.querySelector('[data-h4l-wish-link]')) return;

    var warenkorb = leiste.querySelector('#cart-icon-bubble') || leiste.querySelector('a[href*="/cart"]');
    var link = document.createElement('a');
    link.href = '/pages/wishlist';
    link.className = 'header__icon header__icon--summary link focus-inset h4l-wishlink';
    link.setAttribute('data-h4l-wish-link', '');
    link.innerHTML =
      '<span class="h4l-wishlink__i">' +
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8L3.5 9.7l5.9-.9z"/></svg>' +
      '<span class="h4l-wishlink__c" data-h4l-wish-count hidden>0</span>' +
      '</span><span class="visually-hidden">Wunschliste</span>';

    if (warenkorb && warenkorb.parentNode === leiste) {
      leiste.insertBefore(link, warenkorb);
    } else {
      leiste.appendChild(link);
    }
    zaehlerAktualisieren();
  }

  /* --- Wunschlisten-Seite ------------------------------------------------- */
  function seiteRendern() {
    var raster = document.querySelector('[data-h4l-wish-grid]');
    if (!raster) return;
    var leer = document.querySelector('[data-h4l-wish-empty]');
    var handles = lesen();

    raster.innerHTML = '';

    if (!handles.length) {
      if (leer) leer.hidden = false;
      return;
    }
    if (leer) leer.hidden = true;

    handles.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (a) { return a.ok ? a.json() : null; })
        .then(function (p) {
          if (!p) { entfernen(handle); return; }

          var preis = (p.price / 100).toFixed(2).replace('.', ',') + ' €';
          var bild = p.featured_image ? p.featured_image : '';

          var karte = document.createElement('article');
          karte.className = 'h4l-wcard';
          karte.innerHTML =
            '<a class="h4l-wcard__i" href="/products/' + handle + '">' +
            (bild ? '<img src="' + bild + '&width=700" alt="' + p.title.replace(/"/g, '') + '" loading="lazy">' : '') +
            '</a>' +
            '<div class="h4l-wcard__b">' +
            '<h3><a href="/products/' + handle + '">' + p.title + '</a></h3>' +
            '<p class="h4l-wcard__p">' + preis + '</p>' +
            '<button type="button" class="h4l-wcard__x" data-h4l-wish-remove="' + handle + '">Entfernen</button>' +
            '</div>';
          raster.appendChild(karte);
        })
        .catch(function () {});
    });
  }

  document.addEventListener('click', function (e) {
    var knopf = e.target.closest('[data-h4l-wish-remove]');
    if (!knopf) return;
    entfernen(knopf.getAttribute('data-h4l-wish-remove'));
    seiteRendern();
  });

  function start() {
    headerSymbol();
    sterneVorbereiten();
    zaehlerAktualisieren();
    seiteRendern();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
